module.exports = __webpack_public_path__ + "static/img/16.5806ea6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/16.jpg
// module id = Tivh
// module chunks = 0